export default "__VITE_ASSET__izZIaSGG__"